import { createContext, useContext, type ReactNode } from 'react';

type ChangeLanguageConfig = {
  reloadOnChange: boolean;
};

const ChangeLanguageConfigContext = createContext<ChangeLanguageConfig>({
  reloadOnChange: false,
});

type ChangeLanguageConfigProviderProps = {
  children: ReactNode;
  reloadOnChange?: boolean;
};

export function ChangeLanguageConfigProvider({
  children,
  reloadOnChange = false,
}: ChangeLanguageConfigProviderProps) {
  return (
    <ChangeLanguageConfigContext.Provider value={{ reloadOnChange }}>
      {children}
    </ChangeLanguageConfigContext.Provider>
  );
}

export function useChangeLanguageConfig() {
  return useContext(ChangeLanguageConfigContext);
}
